import React from "react";
import { BentoDashboardCoursePage } from "./CoursePageDesignsCore";
import MetaInfo from "./components/MetaInfo";
import Header from "./components/Header";
import Footer from "./components/Footer";

export default function CourseDetails6(props) {
    return (
        <>
            <MetaInfo />
            <Header school="common" />
            <BentoDashboardCoursePage {...props} />;
            <Footer />
        </>
    )
};
